import React from 'react';
import { StyleSheet, TouchableOpacity, View, ActivityIndicator } from 'react-native';
import Icon from './Icon';
import BaseText from './BaseText';

import { Color, CommonProperties, CommonStyles } from '../styles';

export const BUTTON_TYPES = {
  CONTAINED: 0,
  OUTLINED: 1,
  TEXT: 2,
};

const Button = ({
  type = BUTTON_TYPES.CONTAINED,
  style,
  labelStyle,
  iconName,
  iconSize,
  iconColor,
  children,
  disabled,
  onPress,
  rounded,
  color = Color.primary,
  label = '',
  loading,
  ...rest
}) => {
  let _style = {};
  let roundedStyle = {};
  let colorStyle = {};

  if (rounded) {
    roundedStyle = {
      height: rounded,
      borderRadius: rounded / 2,
    };
  }

  switch (type) {
    case BUTTON_TYPES.OUTLINED:
      _style = outlinedStyle;

      if (color) {
        colorStyle = {
          button: {
            borderColor: color,
          },
          text: {
            color,
          },
        };
      }
      break;
    case BUTTON_TYPES.TEXT:
      _style = textStyle;

      if (color) {
        colorStyle.text = {
          color,
        };
      }
      break;
    case BUTTON_TYPES.CONTAINED:
    default:
      _style = containedStyle;

      if (color) {
        colorStyle.button = {
          backgroundColor: color,
        };
      }
  }

  return (
    <TouchableOpacity
      style={[
        CommonStyles.p3,
        CommonStyles.borderRadius,
        roundedStyle,
        _style.button,
        color ? colorStyle.button : null,
        // disabled ? _style.disableButton : null,
        style,
      ]}
      disabled={disabled}
      onPress={(e) => {
        if (!disabled) {
          onPress(e);
        }
      }}
      {...rest}
    >
      {!children && (
        <View style={styles.innerButton}>
          {iconName && (
            <Icon
              style={styles.icon}
              name={iconName}
              size={iconSize ? iconSize : null}
              color={disabled ? _style.disableText : iconColor || Color.primary}
            />
          )}
          <BaseText
            style={[
              disabled ? _style.disableText : _style.text,
              styles.text,
              colorStyle.text,
              labelStyle,
            ]}
            numberOfLines={1}
            ellipsizeMode={'tail'}
          >
            {label}
          </BaseText>
          {!!loading && (
            <ActivityIndicator
              styles={styles.loadingIndicator}
              color={Color.accent}
            ></ActivityIndicator>
          )}
        </View>
      )}
    </TouchableOpacity>
  );
};

const outlinedStyle = StyleSheet.create({
  button: {
    borderWidth: 1,
    borderColor: Color.primary,
  },
  disableButton: {
    borderWidth: 1,
    borderColor: Color.disabled,
  },
  text: {
    color: Color.primary,
  },
  disableText: {
    color: Color.text.low,
  },
});

const textStyle = StyleSheet.create({
  text: {
    color: Color.primary,
  },
  disableText: {
    color: Color.text.low,
  },
});

const containedStyle = StyleSheet.create({
  button: {
    backgroundColor: Color.primary,
  },
  disableButton: {
    backgroundColor: Color.disabled,
  },
  text: {
    color: Color.accent,
  },
  disableText: {
    color: Color.accent,
  },
});

const styles = StyleSheet.create({
  innerButton: {
    flexDirection: 'row',
    ...CommonProperties.centerAlignment,
  },
  text: {
    ...CommonProperties.body,
  },
  icon: {
    ...CommonProperties.mr3,
  },
  loadingIndicator: {
    ...CommonProperties.mr3,
  },
});

export default Button;
